






















































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import productoModule from "@/store/modules/producto-module";
import { producto } from "@/shared/dtos/producto";
import ocultarcamposModule from "@/store/modules/ocultarcampos-module";
import { ProductoAmazon } from "@/shared/dtos/productosAmazon/ProductoAmazon";
import TiendaOnlineClientesModule from "@/store/modules/TiendaOnlineClientes-module";
import { ImagenProducto } from "@/shared/dtos/productosAmazon/ImagenProducto";
import ProcesosProducto from "../procesos/Procesos_producto.vue";

@Component({
  components: {
    ProcesosProducto,
  },
})
export default class FichaProducto extends Vue {
  public item_pantalla: producto = new producto();
  public item_amazon: ProductoAmazon = new ProductoAmazon();
  public mainImage = "https://via.placeholder.com/500x500.png?text=Producto";

  public async created() {
    const idParam = this.$route.params.id;
    if (idParam && idParam !== "0") {
      await productoModule.getproducto(Number(idParam));
      await TiendaOnlineClientesModule.getTiendaOnlineClientes(Number(idParam));
      
      this.item_pantalla = { ...productoModule.producto } as producto;
      this.item_amazon = { ...TiendaOnlineClientesModule.TiendaOnlineClientes } as ProductoAmazon;
      
      if (this.item_amazon && this.item_amazon.hiRes) {
        this.mainImage = this.item_amazon.hiRes;
      }
    }

    // Cálculos iniciales
    this.calcularGanancia();
    this.item_pantalla.precio_venta = Math.ceil((this.item_pantalla.total_retail || 0) * 0.5);
    this.item_pantalla.item_pkg_weight = Math.ceil(this.item_pantalla.item_pkg_weight || 0);
  }

  get mostrarCamposCoste() {
    return ocultarcamposModule.mostrar_campos_coste;
  }

  get fechaEnvioModel() {
    if (!this.item_pantalla.shipment_closed) return "";
    const d = new Date(this.item_pantalla.shipment_closed);
    if (isNaN(d.getTime())) return "";
    return d.toISOString().split("T")[0];
  }

  set fechaEnvioModel(val: string) {
    if (val) {
      this.item_pantalla.shipment_closed = new Date(val).toISOString();
    }
  }

  public calcularGanancia() {
    const vendido = Number(this.item_pantalla.precio_vendido) || 0;
    const coste = Number(this.item_pantalla.coste_compra) || 0;
    this.item_pantalla.ganado = Number((vendido - coste).toFixed(2));
  }

  public changeMainImage(image: ImagenProducto) {
    this.mainImage = image.hiRes;
  }

  public async downloadAllImages(images: ImagenProducto[]) {
    if (!images || images.length === 0) return;
    for (const [index, image] of images.entries()) {
      const fileName = (this.item_pantalla.asin || 'producto') + `_${index + 1}.jpg`;
      await this.downloadImage(image.hiRes, fileName);
    }
  }

  private async downloadImage(url: string, fileName: string) {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Error al descargar la imagen:", error);
    }
  }

  public Cancelar() {
    this.$router.back();
  }

  public async Guardar() {
    try {
      if (this.item_pantalla.id && this.item_pantalla.id > 0) {
        await productoModule.modificarproducto(this.item_pantalla);
      } else {
        await productoModule.guardarproducto(this.item_pantalla);
      }
      this.Cancelar();
    } catch (err) {
      console.error("Error guardando el producto:", err);
    }
  }
}
